import { SupportedMessageFormats } from "../../../Contracts";
import { RequestFormatter, getRequesterIds } from "../../../Common";
import { STR_ERRORS } from "../../Strings";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
export function SDQRequestFormatter(query) {
    const id = SDQuerySubscribersStore.getQueryID(query);
    const requesterId = getRequesterIds(SDQuerySubscribersStore, query);
    let message = "";
    if (query.name === "Unsubscribe") {
        message = RequestFormatter({
            type: SupportedMessageFormats["jsonrpc2.0"],
            channel: query.name,
            data: {},
            meta: {},
            id: query.params.id
        });
    }
    else {
        if (typeof id === "undefined") {
            throw new Error(STR_ERRORS.SDQRequestFormatRequiresActiveQuery);
        }
        message = RequestFormatter({
            type: SupportedMessageFormats["jsonrpc2.0"],
            channel: query.name,
            data: query.params,
            meta: {
                requesterId
            },
            id
        });
    }
    return message;
}
//# sourceMappingURL=SDQRequestFormatter.js.map